import { UserProfileForm } from "../../components/UserProfile/UserProfileForm";

export function UserProfile() {
  return <UserProfileForm />;
}
